export default __webpack_public_path__ + "static/media/casino.afd4f337.webp";